import { PortfolioHiststoricalDataQuery$data } from '@bts-web/data-layer/server';

export type NonNullablePortfolioResponse = NonNullable<
  NonNullable<PortfolioHiststoricalDataQuery$data>['portfolio']
>;

export enum AssetTypeName {
  COIN = 'coin',
  METAL = 'metal',
  ETF = 'etf',
  ETC = 'etc',
  STOCK = 'stock',
}
